export const programs = [
  {
    name: 'ETT Excellent Trade Training of HVAC',
    type: 'Short-term trade program',
    credential: 'EPA Universal Certification Preparation',
    format: 'Evening classes (Tue/Thu 6:00 PM – 9:00 PM)',
    length: '5 weeks',
    tuition: '$1,850',
    admissions: 'No prerequisites; open enrollment',
    summary:
      'An intensive program focused on hands-on HVAC skill development, troubleshooting, and preparation for the EPA Universal Certification.',
    mapUrl:
      'https://maps.google.com/?q=ETT+Excellent+Trade+Training+of+HVAC&ftid=0x8640cf4b4792739f:0x89254edf6c2df38e',
    badge: 'Short-term trade program',
    websiteUrl: 'https://ett-hvactraining.com',
    specs: [
      ['Program type', 'Short-term trade program'],
      ['Credential', 'EPA Universal Certification Preparation'],
      ['Class format', 'Evening classes (Tue/Thu 6:00 PM – 9:00 PM)'],
      ['Program length', '5 weeks'],
      ['Tuition', '$1,850'],
      ['Admissions requirements', 'No prerequisites; open enrollment'],
    ],
    paragraphs: [
      'An intensive program focused on hands-on HVAC skill development, troubleshooting, and preparation for the EPA Universal Certification.',
    ],
    highlights: [
      'Hands-on HVAC skill development',
      'Troubleshooting practice',
      'EPA Universal Certification preparation',
    ],
    address: 'ETT Excellent Trade Training of HVAC, Houston, TX',
    mapListingUrl:
      'https://maps.google.com/?q=ETT+Excellent+Trade+Training+of+HVAC&ftid=0x8640cf4b4792739f:0x89254edf6c2df38e',
  },
  {
    name: 'The Training Center Of Air Conditioning & Heating',
    type: 'Hands-on trade school',
    credential: 'Certificate of Completion / EPA Prep',
    format: 'Campus based',
    length: 'Confirm with provider',
    tuition: 'Request current pricing',
    admissions: 'Contact the training provider',
    summary:
      'A practical, hands-on school utilizing the Chris Walters method taught by industry veterans with decades of field experience.',
    mapUrl:
      'https://maps.google.com/?q=The+Training+Center+Of+Air+Conditioning+%26+Heating&ftid=0x8640cddbf6d06865:0x4e892a618461ab6a',
    badge: 'Hands-on trade school',
    websiteUrl:
      'https://thetrainingcenterofairconditioningandheating.com',
    specs: [
      ['Program type', 'Hands-on trade school'],
      ['Credential', 'Certificate of Completion / EPA Prep'],
      ['Class format', 'Campus based'],
      ['Program length', 'Confirm with provider'],
      ['Tuition', 'Request current pricing'],
      ['Admissions requirements', 'Contact the training provider'],
    ],
    paragraphs: [
      'A practical, hands-on school utilizing the Chris Walters method taught by industry veterans with decades of field experience.',
    ],
    highlights: [
      'Campus-based hands-on training',
      'Chris Walters method',
      'Instruction from experienced industry veterans',
    ],
    address:
      'The Training Center Of Air Conditioning & Heating, Houston, TX',
    mapListingUrl:
      'https://maps.google.com/?q=The+Training+Center+Of+Air+Conditioning+%26+Heating&ftid=0x8640cddbf6d06865:0x4e892a618461ab6a',
  },
  {
    name: 'Houston Trade Training LLC',
    type: 'Short-term certificate course',
    credential: 'HVAC Training & EPA Certification Prep',
    format: 'Saturday sessions (10:00 AM – 2:00 PM)',
    length: '8 weeks',
    tuition: 'Request current pricing (includes registration fee)',
    admissions: 'Contact the training provider',
    summary:
      'Flexible weekend training designed to give working students practical instruction in HVAC fundamentals and exam prep.',
    mapUrl:
      'https://maps.google.com/?q=Houston+Trade+Training+LLC&ftid=0x8640cbe2f147f43f:0x9e036419a4bbe85e',
    badge: 'Short-term certificate course',
    websiteUrl: 'https://houstontradetraining.com',
    specs: [
      ['Program type', 'Short-term certificate course'],
      ['Credential', 'HVAC Training & EPA Certification Prep'],
      ['Class format', 'Saturday sessions (10:00 AM – 2:00 PM)'],
      ['Program length', '8 weeks'],
      ['Tuition', 'Request current pricing (includes registration fee)'],
      ['Admissions requirements', 'Contact the training provider'],
    ],
    paragraphs: [
      'Flexible weekend training designed to give working students practical instruction in HVAC fundamentals and exam prep.',
    ],
    highlights: [
      'Weekend training format',
      'HVAC fundamentals',
      'EPA certification preparation',
    ],
    address: 'Houston Trade Training LLC, Houston, TX',
    mapListingUrl:
      'https://maps.google.com/?q=Houston+Trade+Training+LLC&ftid=0x8640cbe2f147f43f:0x9e036419a4bbe85e',
  },
  {
    name: 'DoHVAC Houston',
    type: 'Hands-on trade school',
    credential: 'HVAC Technical Certification & EPA Prep',
    format: 'Night & Weekend options (Tue/Thu evenings or Saturdays)',
    length: '5 to 10 weeks',
    tuition: 'Request current pricing',
    admissions: 'Contact the training provider',
    summary:
      'Features extensive mock-up lab training with instructors boasting over 25 years of experience in residential and commercial systems.',
    mapUrl:
      'https://maps.google.com/?q=DoHVAC+Houston&ftid=0x8640c53013846c21:0x756cdfe045ae2bde',
    badge: 'Hands-on trade school',
    websiteUrl: 'https://dohvac.com',
    specs: [
      ['Program type', 'Hands-on trade school'],
      ['Credential', 'HVAC Technical Certification & EPA Prep'],
      ['Class format', 'Night & Weekend options (Tue/Thu evenings or Saturdays)'],
      ['Program length', '5 to 10 weeks'],
      ['Tuition', 'Request current pricing'],
      ['Admissions requirements', 'Contact the training provider'],
    ],
    paragraphs: [
      'Features extensive mock-up lab training with instructors boasting over 25 years of experience in residential and commercial systems.',
    ],
    highlights: [
      'Extensive mock-up lab training',
      'Residential and commercial systems',
      'Instructors with over 25 years of experience',
    ],
    address: 'DoHVAC Houston, Houston, TX',
    mapListingUrl:
      'https://maps.google.com/?q=DoHVAC+Houston&ftid=0x8640c53013846c21:0x756cdfe045ae2bde',
  },
  {
    name: 'Career Training School',
    type: 'Accredited career school (TWC approved)',
    credential: 'HVAC/R Maintenance Certification',
    format: 'Campus based (Mon–Sat)',
    length: 'Confirm with provider',
    tuition: 'Financial assistance / payment plans available',
    admissions: 'Contact admissions department',
    summary:
      'A Texas Workforce Commission-approved program offering comprehensive training in electrical theory, installation, and refrigeration recovery.',
    mapUrl:
      'https://maps.google.com/?q=Career+Training+School&ftid=0x8640cbcbc7ee74c5:0xcb2882a97bc305b6',
    badge: 'Accredited career school (TWC approved)',
    websiteUrl: 'https://hvacschoolhouston.com',
    specs: [
      ['Program type', 'Accredited career school (TWC approved)'],
      ['Credential', 'HVAC/R Maintenance Certification'],
      ['Class format', 'Campus based (Mon–Sat)'],
      ['Program length', 'Confirm with provider'],
      ['Tuition', 'Financial assistance / payment plans available'],
      ['Admissions requirements', 'Contact admissions department'],
    ],
    paragraphs: [
      'A Texas Workforce Commission-approved program offering comprehensive training in electrical theory, installation, and refrigeration recovery.',
    ],
    highlights: [
      'Texas Workforce Commission-approved program',
      'Electrical theory and installation',
      'Refrigeration recovery training',
    ],
    address: 'Career Training School, Houston, TX',
    mapListingUrl:
      'https://maps.google.com/?q=Career+Training+School&ftid=0x8640cbcbc7ee74c5:0xcb2882a97bc305b6',
  },
  {
    name: 'Texas Technical Trade School',
    type: 'Short-term technical trade school',
    credential: 'HVAC Technician Certificate',
    format: 'Night classes (Mon–Thu 6:00 PM – 10:00 PM)',
    length: '12 weeks (200 hours)',
    tuition: 'Request current pricing',
    admissions: 'Domestic students residing in the US; apply via admissions',
    summary:
      'A TWC-approved program delivering career-focused instruction in residential and commercial heating, ventilation, and cooling systems.',
    mapUrl:
      'https://maps.google.com/?q=Texas+Technical+Trade+School&ftid=0x86407b5b9f57dfbb:0xa46e0b72a6ede0eb',
    badge: 'Short-term technical trade school',
    websiteUrl: 'https://texastechtrade.com',
    specs: [
      ['Program type', 'Short-term technical trade school'],
      ['Credential', 'HVAC Technician Certificate'],
      ['Class format', 'Night classes (Mon–Thu 6:00 PM – 10:00 PM)'],
      ['Program length', '12 weeks (200 hours)'],
      ['Tuition', 'Request current pricing'],
      [
        'Admissions requirements',
        'Domestic students residing in the US; apply via admissions',
      ],
    ],
    paragraphs: [
      'A TWC-approved program delivering career-focused instruction in residential and commercial heating, ventilation, and cooling systems.',
    ],
    highlights: [
      'Texas Workforce Commission-approved program',
      'Residential and commercial HVAC systems',
      '200-hour technician certificate pathway',
    ],
    address: 'Texas Technical Trade School, Houston, TX',
    mapListingUrl:
      'https://maps.google.com/?q=Texas+Technical+Trade+School&ftid=0x86407b5b9f57dfbb:0xa46e0b72a6ede0eb',
  },
  {
    name: 'National Technical Institute - Jersey Village',
    type: 'Accelerated technical training institute',
    credential: 'HVAC/R Fast-Track Certification',
    format: 'Flexible day and evening options',
    length: '2 to 4 months',
    tuition: 'Request current pricing',
    admissions: 'Contact the training provider',
    summary:
      'Accelerated trade programs built in partnership with industry leaders to get students job-ready quickly with hands-on lab experience.',
    mapUrl:
      'https://maps.google.com/?q=National+Technical+Institute+-+Jersey+Village&ftid=0x8640d579b54d2425:0x18802283c4e3baee',
    badge: 'Accelerated technical training institute',
    websiteUrl: 'https://ntitraining.com',
    specs: [
      ['Program type', 'Accelerated technical training institute'],
      ['Credential', 'HVAC/R Fast-Track Certification'],
      ['Class format', 'Flexible day and evening options'],
      ['Program length', '2 to 4 months'],
      ['Tuition', 'Request current pricing'],
      ['Admissions requirements', 'Contact the training provider'],
    ],
    paragraphs: [
      'Accelerated trade programs built in partnership with industry leaders to get students job-ready quickly with hands-on lab experience.',
    ],
    highlights: [
      'Accelerated HVAC/R training',
      'Industry partnership approach',
      'Hands-on lab experience',
    ],
    address: 'National Technical Institute - Jersey Village, Houston, TX',
    mapListingUrl:
      'https://maps.google.com/?q=National+Technical+Institute+-+Jersey+Village&ftid=0x8640d579b54d2425:0x18802283c4e3baee',
  },
];

export const resources = [
  {
    title: 'Air-Conditioning, Heating, and Refrigeration Institute',
    description:
      'Explore industry standards, equipment efficiency information, and HVAC career resources.',
    url: 'https://www.ahrinet.org/',
  },
  {
    title: 'EPA Section 608 Technician Certification',
    description:
      'Review federal refrigerant handling requirements and approved certification programs.',
    url: 'https://www.epa.gov/section608',
  },
  {
    title: 'Texas Department of Licensing and Regulation',
    description:
      'Find current Texas air conditioning and refrigeration licensing requirements.',
    url: 'https://www.tdlr.texas.gov/acr/acr.htm',
  },
  {
    title: 'U.S. Bureau of Labor Statistics',
    description:
      'Research HVAC mechanic and installer duties, pay, education, and employment outlook.',
    url: 'https://www.bls.gov/ooh/installation-maintenance-and-repair/heating-air-conditioning-and-refrigeration-mechanics-and-installers.htm',
  },
];